export const virtualSlotPlaceholderSeparator = '_vs_'
export const defaultSlotName = 'slot'
export const IFRAME_WIDGET = 'WIDGET'
export const IFRAME_PAGE = 'PAGE'
export const OOI_WIDGET = 'WIDGET_OUT_OF_IFRAME'
export const OOI_PAGE = 'PAGE_OUT_OF_IFRAME'
export const BLOCKS_WIDGET = 'STUDIO_WIDGET'
export const CE_WIDGET = 'CUSTOM_ELEMENT_WIDGET'
